import Label from "@/components/Label/Label";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Container,
} from "@mui/material";
import React from "react";
import PageOne from "./PageOne";
import PageTwo from "./PageTwo";
import MainBox from "@/components/Box/MainBox";
import { useSelector } from "react-redux";
import { selectProject } from "@/redux/features/Service/serviceSlice";
import PageThree from "./PageThree";

export const steps = [
  "stepper_title_one",
  "stepper_title_two",
  "stepper_title_three"
];

const Layout = () => {

  const service = useSelector(selectProject);

  const getStepContent = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <PageOne />;
      case 1:
        return <PageTwo />;
      case 2:
        return <PageThree />;
      default:
        return "Unknown stepIndex";
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={service.activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>
                <Label id={label} />
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {service.activeStep === steps.length ? (
        <>
          <MainBox
            display="flex"
            sx={{ height: "80vh", width: "95vw", mt: 5, justifyContent: "center", alignItems: "center" }}
          >
            <Label id={"page_finish"} />
          </MainBox>
        </>
      ) : (
        <>
          <Container maxWidth={false} sx={{ width: "95vw", mt: 5 }}>
            <Box sx={{ height: "80vh" }}>{getStepContent(service.activeStep)}</Box>
          </Container>
        </>
      )}
    </Box>
  );
};

export default Layout;
